<template>
	<div class="font-serif text-primary text-4xl sm:text-5xl mb-3 whitespace-pre-line pageTitleComponent">
		<slot></slot>
	</div>
</template>

<script setup></script>

<style scoped></style>
